import {createSelector} from "reselect"
import {RootState} from "redux/store"

export const getPeriods = createSelector(
  (state: RootState) => state.periods,
  (entities) => entities.sort((a, b) => a.position - b.position),
)

